import { Button } from "@mui/material";
import React, { useState } from "react";
import {
  ModalButtonContainer,
  NegativeModalButton,
  PositiveModalButton,
} from "../../../components/Button";
import { useModal } from "../../../components/modal";
import { CustomTextField } from "../../../components/TextFields";
import { SwitchButton } from "../../../components/switch";
import { Row } from "../../../global/styledComponents";
import VideoUploader from "../../../components/uploader/videoUploader";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import objToFromData from "../../../utils/objToFromdata";
import {
  useAddSnackMutation,
  useUpdateSnackMutation,
} from "../../../app/services/snacks.api";
import ImageUploader from "../../../components/uploader/imageUploader";
import { Snack } from "../../../types/snack.api";
import LoadingButton from "../../../components/Button/LoadingButton";
import toastError from "../../../components/notif";
import { apiErrorMessage } from "../../../utils/apiError";

const schema = yup.object().shape({
  title: yup.string().required("عنوان الزامی است."),
  slug: yup.string().required("اسلاگ الزامی است."),
  desc: yup.string().required("توضیحات الزامی است."),
  lock: yup.boolean().required(),
  priority: yup.number(),
});
export default function AddModal({
  courseId,
  snack,
}: {
  courseId: string;
  snack?: Snack;
}) {
  const edit = !!snack;

  const {
    setValue,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: edit
      ? {
          lock: snack.lock,
          title: snack.title,
          slug: snack.slug,
          priority: snack.priority,
          desc: snack.desc,
        }
      : {
          lock: false,
        },
  });
  const { setShow } = useModal();
  const [video, setVideo] = useState<File | null>(null);
  const [banner, setBanner] = useState<File | null>(null);

  const [addSnack, addState] = useAddSnackMutation();
  const [updateSnack, updateState] = useUpdateSnackMutation();
  return (
    <React.Fragment>
      <Row>
        <CustomTextField
          variant="outlined"
          placeholder="عنوان را وارد کنید."
          label="عنوان"
          required
          onChange={(e) => setValue("title", e.target.value)}
          defaultValue={getValues("title")}
          error={!!errors.title}
          helperText={errors.title?.message}
        />
        <CustomTextField
          variant="outlined"
          placeholder="اسلاگ را وارد کنید."
          label="اسلاگ"
          required
          onChange={(e) => setValue("slug", e.target.value)}
          defaultValue={getValues("slug")}
          error={!!errors.slug}
          helperText={errors.slug?.message}
        />
      </Row>
      <CustomTextField
        variant="outlined"
        placeholder="توضیحات را وارد کنید."
        label="توضیحات"
        required
        onChange={(e) => setValue("desc", e.target.value)}
        defaultValue={getValues("desc")}
        error={!!errors.desc}
        helperText={errors.desc?.message}
        multiline
        minRows={2}
        maxRows={4}
      />
      <Row>
        {edit ? (
          <CustomTextField
            variant="outlined"
            placeholder="اولویت را وارد کنید."
            label="اولویت"
            type="number"
            required
            onChange={(e) => setValue("priority", Number(e.target.value))}
            defaultValue={Number(getValues("priority"))}
            error={!!errors.priority}
            helperText={errors.priority?.message}
          />
        ) : null}
        <SwitchButton
          label="قفل شده"
          onChange={(ch) => {
            setValue("lock", ch);
          }}
          defaultValue={getValues("lock")}
        />
      </Row>
      <ImageUploader title="بنر (اختیاری)" onChange={(e) => setBanner(e)} />
      <VideoUploader required={!edit} title="ویدیو" onChange={(e) => setVideo(e)} />
      <ModalButtonContainer>
        <Button
          style={NegativeModalButton}
          sx={{
            color: "divider",
            bgcolor: "primary.main",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            ":hover": {
              bgcolor: "divider",
              color: "primary.main",
            },
          }}
          onClick={() => setShow(false)}
        >
          انصراف
        </Button>
        <LoadingButton
          style={PositiveModalButton}
          sx={{
            ":hover": {
              bgcolor: "customColors.purple",
              color: "secondary.main",
            },
          }}
          isLoading={addState.isLoading || updateState.isLoading}
          onClick={handleSubmit(
            (data) => {
            const formData = objToFromData(data);
            const onError = (err: any) => toastError(apiErrorMessage(err));
            if (video) formData.append("video", video);
            if (banner) formData.append("banner", banner);
            if (edit) {
              return updateSnack({
                courseId,
                snackId: snack?._id,
                data: formData,
              })
                .unwrap()
                .then(() => {
                  setShow(false);
                })
                .catch(onError);
            }
            // only the video is required by the backend (banner is optional)
            if (!video) return toastError("فایل ویدیوی جلسه را انتخاب کنید.");
            addSnack({
              courseId,
              data: formData,
            })
              .unwrap()
              .then(() => setShow(false))
              .catch(onError);
            },
            (errs) =>
              toastError(
                "فرم کامل نیست: " +
                  Object.values(errs)
                    .map((e: any) => e?.message)
                    .filter(Boolean)
                    .join("، ")
              )
          )}
        >
          تایید
        </LoadingButton>
      </ModalButtonContainer>
    </React.Fragment>
  );
}
